import Flex from 'components/priority/Flex/Flex'
import Text from 'components/priority/Text/Text'
import { ToggleSwitch } from 'components/global/ToggleSwitch/ToggleSwitch'
import { useRecoilState } from 'recoil'
import { itemSelector } from 'atoms'
import { useIsAdmin } from '@/hooks/utility/useIsAdmin'
import { useTranslation } from 'react-i18next'

export const LockAsset = ({ selectedItem }) => {
  const { t } = useTranslation()
  const isAdmin = useIsAdmin()
  const [assetLocked, setAssetLocked] = useRecoilState(
    itemSelector({ id: selectedItem, path: 'assetLocked' }),
  )

  if (!isAdmin) {
    return null
  }

  return (
    <>
      <Text margin="0 0 4px">
        {t('editor.menus.properties.elements.lockAssetButton')}
      </Text>
      <Text size="11px" color="gray2" margin="0 0 12px">
        {t('editor.menus.properties.elements.lockAssetLabel')}
      </Text>
      <Flex margin="0 0 24px">
        <ToggleSwitch value={[assetLocked, setAssetLocked]} />
      </Flex>
    </>
  )
}
